import { Link } from 'react-router-dom';
import { CreditCard, X } from '@/components/icons';
import { useSubscriptionSync } from '../../context/SubscriptionSyncContext';

/**
 * Shown when Polar reports an actionable payment failure (past_due/unpaid) on the
 * user's subscription — so a declined renewal is visible in-app instead of the
 * user silently losing Pro. Driven by the sync-on-login payment status.
 */
export function SubscriptionBanner() {
  const { paymentIssue, dismissed, dismiss } = useSubscriptionSync();

  if (dismissed || !paymentIssue?.pastDue) return null;

  return (
    <div className="px-6 pt-6 md:px-8">
      <div className="mx-auto max-w-[1060px]">
        <div
          role="alert"
          className="flex items-start gap-3 rounded-lg border border-amber-300 bg-amber-50 p-3.5 dark:border-amber-800 dark:bg-amber-900/20"
        >
      <div className="mt-0.5 grid h-8 w-8 flex-none place-items-center rounded-full bg-amber-100 dark:bg-amber-900/40">
        <CreditCard className="h-[18px] w-[18px] text-amber-600 dark:text-amber-400" />
      </div>

      <div className="min-w-0 flex-1">
        <h3 className="text-[13.5px] font-semibold text-amber-900 dark:text-amber-100">
          We couldn&rsquo;t process your last payment
        </h3>
        <p className="mt-0.5 text-[12.5px] text-amber-700 dark:text-amber-300">
          Your Pro subscription renewal was declined. Update your payment method to keep your Pro features
          before access ends.
        </p>
        <Link
          to="/billing"
          className="ss-press mt-2 inline-flex items-center gap-1.5 rounded-md bg-amber-600 px-2.5 py-1.5 text-[12px] font-semibold text-white transition-colors hover:bg-amber-700"
        >
          Update payment method
        </Link>
      </div>

      <button
        onClick={dismiss}
        aria-label="Dismiss"
        className="ss-press flex-none rounded-md p-1 text-amber-600 transition-colors hover:bg-amber-200 dark:text-amber-400 dark:hover:bg-amber-800/40"
      >
        <X className="h-4 w-4" />
      </button>
        </div>
      </div>
    </div>
  );
}
